
export const  redirectPage = (url: string) => {
    window.location.replace(url)
}

export const sleep = (timeout: number) =>
  new Promise((resolve) => setTimeout(resolve, timeout))
